import React from 'react';
import { autobind } from 'core-decorators';
import List from '../../../componentes/list';
import ListColumn from '../../../componentes/list/list-column';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import FormulaEdit from '../index';

@autobind
class FormulaPadrao extends React.Component {
  render() {
    let { intl, parameters } = this.props;
    return (
      <List url="/Formula" editComponent={FormulaEdit} sort="descricao" showSearch={true} {...this.props} tag={11002} parameters={{ ...parameters }} {...parameters}>
        <ListColumn headerText={intl.formatMessage({ id: 'idIntegracao' })} valueField="idIntegracao" default />
        <ListColumn headerText={intl.formatMessage({ id: 'descricao' })} required valueField="descricao" sortField="descricao" default />
        <ListColumn headerText={intl.formatMessage({ id: 'label.expressao' })} required valueField="expressao" sortField="expressao" default />
      </List>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(FormulaPadrao));
